<div class="pipeline-workflow-builder">
  <div class="nodes-header" *ngIf="showNodesHeader">
    <div class="nodes-title-group">
      <h2 class="nodes-title">{{ nodesHeaderTitle }}</h2>
      <div class="nodes-meta">{{ nodesHeaderMeta }}</div>
    </div>
    <div class="nodes-header-actions">
      <label class="nodes-search" *ngIf="showHeaderSearch">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <circle cx="6.2" cy="6.2" r="3.7" stroke="currentColor" stroke-width="1.3"/>
          <path d="M9 9l2.6 2.6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
        </svg>
        <input type="search" [(ngModel)]="searchTerm" [placeholder]="searchPlaceholder" />
      </label>

      <button class="btn-add-node" (click)="showAddModal = true">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        {{ addNodeButtonLabel }}
      </button>

      <button class="btn-header-action" *ngIf="showValidateAction" (click)="validate()">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
          <path d="M4 6.7l1.7 1.7L9.4 4.3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
          <rect x="2" y="2" width="9" height="9" rx="1.6" stroke="currentColor" stroke-width="1.1"/>
        </svg>
        {{ validateActionLabel }}
      </button>

      <button class="btn-save-config" *ngIf="showSaveAction" [class.saving]="saveStatus === 'saving'" (click)="save()">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
          <path d="M3 2h5.6l1.4 1.4V11H3V2z" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/>
          <path d="M4.4 2v3h3.4V2M4.4 9.4h4.2" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/>
        </svg>
        {{ saveStatus === 'saving' ? 'Saving...' : saveActionLabel }}
      </button>
    </div>
  </div>

  <div class="master-detail-layout" [class.dock-right]="dockSide === 'right'">
    <div class="flow-sidebar">
      <div class="flow-terminal flow-start" *ngIf="readFlag(startTerminal?.visible, true)">
        <div class="ft-dot"></div>
        <div class="ft-text">
          <span class="ft-label">{{ readText(startTerminal?.label, 'Record submitted') }}</span>
          <span class="ft-entity">{{ readText(startTerminal?.entity, config?.name || '') }}</span>
        </div>
      </div>

      <ng-container *ngIf="!filteredNodes.length && showEmptyState">
        <div class="flow-empty-area">
          <div class="fic-line long"></div>
          <div class="flow-add-first" (click)="showAddModal = true">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            {{ readText(emptyStateConfig?.label, 'Add your first node') }}
          </div>
          <div class="fic-line long"></div>
        </div>
      </ng-container>

      <div
        class="flow-drop-zone"
        cdkDropList
        [cdkDropListData]="filteredNodes"
        (cdkDropListDropped)="dropNode($event)">
        <div
          class="flow-node-item"
          *ngFor="let node of filteredNodes; let i = index"
          cdkDrag
          [cdkDragData]="node"
          [class.active]="node.id === activeNodeId"
          (mouseenter)="onHoverNode(node.id)">
          <div *cdkDragPlaceholder class="flow-placeholder"></div>
          <div *cdkDragPreview class="flow-preview">{{ node.label }}</div>

          <app-pipeline-widget-host
            *ngIf="getFlowNodeTarget(node, i) as target"
            [target]="target">
          </app-pipeline-widget-host>
        </div>
      </div>

      <ng-container *ngIf="filteredNodes.length && showBottomInsert">
        <div class="flow-out-connector">
          <div class="fic-line"></div>
          <button class="fic-insert" (click)="showAddModal = true" [title]="readText(builderUi?.bottomInsert?.tooltip, 'Add node at end')">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
              <path d="M4 1v6M1 4h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
          <div class="fic-line"></div>
          <div class="fic-arrow" *ngIf="readFlag(builderUi?.bottomInsert?.showArrow, true)">
            <svg width="9" height="6" viewBox="0 0 9 6" fill="none">
              <path d="M4.5 6L0 0h9L4.5 6z" fill="currentColor"/>
            </svg>
          </div>
        </div>
      </ng-container>

      <div class="flow-terminal flow-end" *ngIf="readFlag(endTerminal?.visible, true)">
        <div class="ft-dot"></div>
        <div class="ft-text">
          <span class="ft-label">{{ readText(endTerminal?.label, 'All gates passed') }}</span>
          <span class="ft-approved">{{ readText(endTerminal?.entity, 'Approved') }}</span>
        </div>
      </div>
    </div>

    <div class="main-area">
      <app-pipeline-widget-host
        *ngIf="activeNode && getNodeCardTarget(activeNode) as target"
        [target]="target">
      </app-pipeline-widget-host>

      <div class="empty-state" *ngIf="!activeNode && showDetailEmptyState && (data?.nodeCardWidget?.type || data?.components?.nodeCard?.type)">
        <div class="empty-state-icon" *ngIf="readFlag(detailEmptyStateConfig?.showIcon, true)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <rect x="3" y="3" width="18" height="18" rx="4"/>
            <path d="M9 12h6M12 9v6" stroke-linecap="round"/>
          </svg>
        </div>
        <span>{{ readText(detailEmptyStateConfig?.message, 'Hover over a node on the left to see details.') }}</span>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showAddModal" (click)="closeModalOnBackdrop($event)">
    <div class="modal-box" role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <div class="modal-header">
        <h3 id="modal-title">{{ readText(addNodeModalConfig?.title, 'Add flow node') }}</h3>
        <button class="modal-close" (click)="showAddModal = false" aria-label="Close">&#x2715;</button>
      </div>
      <div class="modal-body">
        <p class="modal-hint">{{ readText(addNodeModalConfig?.hint, 'Choose a node type to add to this workflow:') }}</p>
        <div class="node-type-grid">
          <div
            class="node-type-card"
            *ngFor="let nodeType of nodeTypeOptions"
            (click)="addNewNode(nodeType.type)"
            role="button"
            tabindex="0"
            (keydown.enter)="addNewNode(nodeType.type)"
            (keydown.space)="addNewNode(nodeType.type)">
            <div class="node-type-icon" [class.auto]="nodeType.type === 'AUTO_APPROVE'" [class.parallel]="nodeType.type === 'PARALLEL'" [class.hierarchy]="nodeType.type === 'HIERARCHY'">
              <svg *ngIf="nodeType.type === 'AUTO_APPROVE'" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M4 10l4 4 8-8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="nodeType.type === 'PARALLEL'" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 4v12M5 7l5-3 5 3M5 13l5 3 5-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="nodeType.type === 'HIERARCHY'" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="5" r="2" stroke="currentColor" stroke-width="1.5"/>
                <circle cx="5" cy="15" r="2" stroke="currentColor" stroke-width="1.5"/>
                <circle cx="15" cy="15" r="2" stroke="currentColor" stroke-width="1.5"/>
                <path d="M10 7v4M8 11l-1.5 2M12 11l1.5 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <div class="node-type-name">{{ nodeType.title }}</div>
            <div class="node-type-desc">{{ nodeType.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="toast" [class.visible]="toastVisible" role="status" aria-live="polite">{{ toastMessage }}</div>
</div>
